<div class="d-flex flex-column flex-fill dx-card">
    <div class="d-flex flex-row align-items-end mx-4 mt-3">
        <div>
            <label>Statuses</label>
            <dx-tag-box
                [(value)]="filter.statusIds"
                [items]="invoiceStatuses"
                valueExpr="id"
                displayExpr="name"
                [showSelectionControls]="true"
                [showDropDownButton]="true"
                style="min-width: 400px; max-width: 400px"
            ></dx-tag-box>
        </div>
        <dx-form [formData]="filter" style="max-width: 150px" class="ms-4">
            <dxi-form-item dataField="invoiceDateFrom" [label]="{ text: 'Invoice Date From' }" editorType="dxDateBox"></dxi-form-item>
            <dxi-form-item dataField="invoiceDateTo" [label]="{ text: 'To' }" editorType="dxDateBox"></dxi-form-item>
        </dx-form>
        <div class="ms-4">
            <label>Include Deleted</label>
            <dx-check-box [(value)]="filter.includeDeleted" class="ms-2"></dx-check-box>
        </div>
        <button type="button" accesskey="s" (click)="getData()" class="btn btn-primary ms-4">Search</button>
    </div>
    <div class="d-flex flex-column flex-fill p-1">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            class="flex-fill d-flex flex-column"
            height="650px"
            [dataSource]="invoices"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            [columnAutoWidth]="false"
        >
            <dxi-data-grid-column dataField="id" caption="Id" width="75" cellTemplate="invoiceLinkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="createDate" caption="Created" dataType="date" width="125"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="invoiceNumber"
                caption="Invoice #"
                width="75"
                cellTemplate="invoiceLinkTemplate"
            ></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="rentalIdDisplay"
                caption="Rental"
                width="75"
                cellTemplate="rentalLinkTemplate"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="statusName" caption="Status" width="100"> </dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="customerDisplayName"
                caption="Customer"
                width="175"
                cellTemplate="customerLinkTemplate"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="displayServiceAddress" caption="Service Address" width="150"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="paid" dataType="date" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="invoiceDate" dataType="date" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="dueDate" dataType="date" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="200"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="unpaidBalance"
                [format]="{ type: 'currency', precision: 2 }"
                width="150"
            ></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="jobMargin"
                caption="Job Margins"
                [format]="{ type: 'percent', precision: 2 }"
                width="100"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="deleted" dataType="date" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="isPaid" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="isDeleted" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="quickBooksId" caption="QB Id" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="readyToExport" dataType="date" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="quickBooksLastExport"
                caption="QB Last Export"
                dataType="date"
                width="100"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="margins" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column></dxi-data-grid-column>

            <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
                @if (cell) {
                    <a [routerLink]="'/invoices/' + cell.data.id" [innerHtml]="cell.text"></a>
                }
            </div>
            <div *dxTemplate="let cell of 'rentalLinkTemplate'">
                @if (cell && !cell.data.rentalId) {
                    <p [innerHtml]="cell.text"></p>
                }
                @if (cell && cell.data.rentalId) {
                    <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
                }
            </div>
            <div *dxTemplate="let cell of 'customerLinkTemplate'">
                @if (cell) {
                    <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
                }
            </div>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button
          class="btn btn-sm btn-success me-1 mb-2"
          (click)="readyForExport()"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          [hidden]="!isInvoiceAdmin"
          >
          Ready To Export
        </button>
        <button
          class="btn btn-sm btn-success me-1 mb-2"
          (click)="calculateJobMargins()"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          [hidden]="!isInvoiceAdmin"
          >
          ReCalculate Margins
        </button>
      </div>

            <div *dxTemplate="let data of 'toolbarText'">
                @if (dataGrid) {
                    <span class="me-3">
                        <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
                    </span>
                }
            </div>

            <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
            <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
            <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
            <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
            <dxo-data-grid-state-storing
                [enabled]="true"
                type="localStorage"
                storageKey="invoice-history-grid"
            ></dxo-data-grid-state-storing>

            <dxo-data-grid-summary>
                <dxi-data-grid-total-item
                    column="total"
                    summaryType="sum"
                    [displayFormat]="'{0}'"
                    [valueFormat]="{ type: 'currency', precision: 2 }"
                >
                </dxi-data-grid-total-item>
                <dxi-data-grid-total-item
                    column="unpaidBalance"
                    summaryType="sum"
                    [displayFormat]="'{0}'"
                    [valueFormat]="{ type: 'currency', precision: 2 }"
                >
                </dxi-data-grid-total-item>
                <dxi-data-grid-total-item
                    column="jobMargin"
                    summaryType="avg"
                    [displayFormat]="'{0}'"
                    [valueFormat]="{ type: 'percent', precision: 2 }"
                >
                </dxi-data-grid-total-item>
            </dxo-data-grid-summary>
        </dx-data-grid>
    </div>
</div>
